import React, { Component } from 'react'
import Manifesto from './Manifesto';
import afpLogo from './img/afplogo.png'
import jpcLogo from './img/jpclogo.png'

export default class Propaganda extends Component {
    render() {
        return (
            <section className="Propaganda">
                <h2 className="text-center">The Manifestos</h2>
                <hr />
                <Manifesto
                    icon= { jpcLogo }
                    name= "Jollof Peoples Congress"
                    body= "The party for the forward-thinking. Not to be mistaken for the Japa FC, the
                    JPC party is comprised of the Nigerian youth ready to build this great nation and ensure that
                    we all eat at the national table - one plate of jollof at a time
                    JPC supports the right of every Nigerian to lift the lid without getting caught, claim rights to
                    the rice at the bottom of the pot and snot their noses at non-Nigerian jollof.
                    The party also supports Nigerian’s rights to walk out of every event that doesn’t include
                    Jollof and opposes the infringement of stew on our God-given jollof rights (rice).
                    The JPC believes that jollof is an essential Nigerian freedom and opposes any laws placing
                    unnecessary restrictions on those seeking to exercise that freedom such as dieting, bans on
                    firewood cooking and fried rice.
                    We fight for a country where everyone has a shot at the Nigerian dream; unlimited
                    “bazeing.”"
                />
                <Manifesto
                    icon= { afpLogo }
                    name= "Asun For Progress"
                    body= "The party for those who believe progress doesn’t mean letting go of what
                    has made us great. The party believes in endurance and discipline and that no nation is built
                    without hard work, determination and a lot of pepper.
                    The party first came into power when it won control of both houses of the Nighttime
                    Congress. Wrestling it from the arms of the hitherto ruling party; Suya for Pleasure
                    
                    The AFP’s mascot is the sacrificial goat symbolising our strong belief in laying down one’s
                    ego and ambition for the benefit of the whole.
                    The party has resisted all attempts to ensure the availability of asun in the daytime as we
                    believe anything worth eating is worth waiting for.
                    The AFP believes in cordial relationships built on shared values (rather than competition)
                    with our West African neighbours, unlike some other parties."
                />
            </section>
        )
    }
}
